import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    /* TICKETS */

    async syncTickets({ commit }) {
      try {
        return await api.get(`/chrons/tickets`)
      } catch (error) {
        throw error
      }
    },

    async getTickets({ commit }, filters) {
      try {
        const params = new URLSearchParams(filters)

        const response = await api.get(`/registers/tickets?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getTicket({ commit }, ticketId) {
      try {
        const response = await api.get(`/registers/tickets/${ticketId}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async updateTicket({ commit }, data) {
      try {
        return await api.put(`/registers/tickets/${data.ticketId}`, data.ticket)
      } catch (error) {
        throw error
      }
    },

    /* TICKETS LOGS */
    async syncTicketLogs({ commit }, ticketId) {
      try {
        return await api.post(`/registers/tickets/${ticketId}/logs`)
      } catch (error) {
        throw error
      }
    },

    async getTicketLogs({ commit }, ticketId) {
      try {
        const response = await api.get(`/registers/tickets/${ticketId}/logs`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    /* LOGS */
    async syncTicketsLogs({ commit }, data) {
      try {
        return await api.post(`/registers/tickets-logs`, data)
      } catch (error) {
        throw error
      }
    },

    async syncTicketsLogsWithOutUsers({ commit }) {
      try {
        return await api.get(`/chrons/tickets-logs-without-users`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
